import React from 'react';

// Lazy-loaded Admin Views
const AdminDashboard = React.lazy(() => import('../pages/admin/Dashboard/AdminDashboard'));
const AdminUsers = React.lazy(() => import('../pages/admin/Customers/AdminUsers'));
const AdminWorkspaces = React.lazy(() => import('../pages/admin/Customers/AdminWorkspaces'));
const AdminPlans = React.lazy(() => import('../pages/admin/Subscriptions/AdminPlans'));
const AdminUsageCredits = React.lazy(() => import('../pages/admin/Subscriptions/AdminUsageCredits'));
const AdminWhatsAppAccounts = React.lazy(() => import('../pages/admin/WhatsApp/AdminWhatsAppAccounts'));
const AdminMessageLogs = React.lazy(() => import('../pages/admin/WhatsApp/AdminMessageLogs'));
const AdminAIUsage = React.lazy(() => import('../pages/admin/AI/AdminAIUsage'));
const AdminAIProviders = React.lazy(() => import('../pages/admin/AI/AdminAIProviders'));
const AdminMCPServers = React.lazy(() => import('../pages/admin/MCP/AdminMCPServers'));
const AdminMCPTools = React.lazy(() => import('../pages/admin/MCP/AdminMCPTools'));
const AdminMCPApps = React.lazy(() => import('../pages/admin/MCP/AdminMCPApps'));
const AdminMCPExecutions = React.lazy(() => import('../pages/admin/MCP/AdminMCPExecutions'));
const AdminAutomations = React.lazy(() => import('../pages/admin/Automation/AdminAutomations'));
const AdminAutomationExecutions = React.lazy(() => import('../pages/admin/Automation/AdminAutomationExecutions'));
const AdminRoles = React.lazy(() => import('../pages/admin/settings/AdminRoles'));
const AdminPermissions = React.lazy(() => import('../pages/admin/settings/AdminPermissions'));
const AdminAuditLogs = React.lazy(() => import('../pages/admin/settings/AdminAuditLogs'));
const AdminSystemSettings = React.lazy(() => import('../pages/admin/settings/AdminSystemSettings'));
const AdminProfile = React.lazy(() => import('../pages/admin/profile/AdminProfile'));

export interface AdminRouteItem {
    path: string;
    name: string;
    component: React.ComponentType<any>;
    exact?: boolean;
    permission?: string;
}

export const adminProtectedRoutes: AdminRouteItem[] = [
    {
        path: '/admin/dashboard',
        name: 'Dashboard',
        component: AdminDashboard,
        exact: true,
    },
    {
        path: '/admin/customers/users',
        name: 'Users',
        component: AdminUsers,
        exact: true,
        permission: 'customers.view',
    },
    {
        path: '/admin/customers/workspaces',
        name: 'Workspaces',
        component: AdminWorkspaces,
        exact: true,
        permission: 'customers.view',
    },
    {
        path: '/admin/subscriptions',
        name: 'Subscription Plans',
        component: AdminPlans,
        exact: true,
        permission: 'subscriptions.view',
    },
    {
        path: '/admin/subscriptions/usage',
        name: 'Credits & Usage',
        component: AdminUsageCredits,
        exact: true,
        permission: 'subscriptions.view',
    },
    {
        path: '/admin/whatsapp/accounts',
        name: 'WhatsApp Accounts',
        component: AdminWhatsAppAccounts,
        exact: true,
        permission: 'whatsapp.view',
    },
    {
        path: '/admin/whatsapp/message-logs',
        name: 'WhatsApp Message Logs',
        component: AdminMessageLogs,
        exact: true,
        permission: 'whatsapp.view',
    },
    {
        path: '/admin/ai/usage',
        name: 'AI Usage',
        component: AdminAIUsage,
        exact: true,
        permission: 'ai.view',
    },
    {
        path: '/admin/ai/providers',
        name: 'AI Providers',
        component: AdminAIProviders,
        exact: true,
        permission: 'ai.view',
    },
    {
        path: '/admin/mcp/servers',
        name: 'MCP Servers',
        component: AdminMCPServers,
        exact: true,
        permission: 'mcp.view',
    },
    {
        path: '/admin/mcp/tools',
        name: 'MCP Tools',
        component: AdminMCPTools,
        exact: true,
        permission: 'mcp.view',
    },
    {
        path: '/admin/mcp/apps',
        name: 'User Apps',
        component: AdminMCPApps,
        exact: true,
        permission: 'mcp.view',
    },
    {
        path: '/admin/mcp/executions',
        name: 'MCP Executions',
        component: AdminMCPExecutions,
        exact: true,
        permission: 'mcp.view',
    },
    {
        path: '/admin/automation/list',
        name: 'Automations',
        component: AdminAutomations,
        exact: true,
        permission: 'automation.view',
    },
    {
        path: '/admin/automation/executions',
        name: 'Automation Executions',
        component: AdminAutomationExecutions,
        exact: true,
        permission: 'automation.view',
    },
    {
        path: '/admin/settings/roles',
        name: 'Roles',
        component: AdminRoles,
        exact: true,
        permission: 'settings.view',
    },
    {
        path: '/admin/settings/permissions',
        name: 'Permissions',
        component: AdminPermissions,
        exact: true,
        permission: 'settings.view',
    },
    {
        path: '/admin/settings/audit-logs',
        name: 'Audit Logs',
        component: AdminAuditLogs,
        exact: true,
        permission: 'settings.view',
    },
    {
        path: '/admin/settings/system',
        name: 'System Settings',
        component: AdminSystemSettings,
        exact: true,
        permission: 'settings.view',
    },
    {
        path: '/admin/profile',
        name: 'Admin Profile',
        component: AdminProfile,
        exact: true,
    },
];
